import * as React from "react";
import * as ReactDOM from "react-dom";
import * as moment from "moment";
import { ActivityType } from "../../enumerations";
import { IActivity } from "../../models/get";
import { OptionalLink } from "../optionalLink";

interface IProperties
{
    /**
     * Inline-Style zum überschreiben des Standard Styles.
     */
    style?: React.CSSProperties,

    /**
     * Der Index des Items.
     */
    index?: number,

    /**
     * Kann die DataSource von dem der eigentliche Text stammt, enthalten.
     */
    dataSource?: IActivity,

    /**
     * Link zum Profilbild.
     */
    profilePicture?: string,

    /**
     * Haupt Anzeige Text.
     */
    text?: string,

    /**
     * Sub Anzeige Text.
     */
    subText?: string,

    /**
     * Die Farbe des Kalenders.
     */
    date?: moment.Moment,

    /**
     * Gibt an, ob das Item selektiert ist.
     */
    isSelected?: boolean,

    /**
     * Wird ausgeführt, sobald auf das Item geklickt wird.
     */
    onClick?: (dataSource: IActivity, index?: number, e?: MouseEvent) => void
}

export class ListViewActivityItem extends React.Component<IProperties>
{
    /**
     * Führe die "onClick" Eigenschaft aus wenn diese gesetzt wurde.
     * @param e Das auslösende Ereignis.
     */
    private onClick = (e: React.MouseEvent<HTMLElement>) =>
    {
        var { dataSource, index, onClick } = this.props;
        onClick && onClick(dataSource, index, e.nativeEvent);
    }

    /**
     * Rendert die Komponente.
     */
    public render(): JSX.Element
    {
        const { style, profilePicture, text, subText, date, isSelected } = this.props;

        // CSS Klasse generieren.
        var classNames: string[] = ["listview-activity-item"];

        if (isSelected)
            classNames.push("listview-activity-item--selected");

        return (
            <div
                className={classNames.join(" ")}
                style={style}
                onClick={this.onClick}>
                <img
                    className="listview-activity-item_img"
                    src={profilePicture} />
                <div className="listview-activity_item_text">{text}</div>
                <div className="listview-activity_item_subtext">{subText}</div>
                <div className="listview-activity_item_date">{date.format("LLLL")}</div>
            </div>
        );
    }
}